"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormStatus = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var FormStatus = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    return react_1.default.createElement("div", { className: 'storybook-playlists-form-status' },
        react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3' }, "Abonnement wijzigen"),
        react_1.default.createElement("div", null,
            react_1.default.createElement(storybook_1.Texts.Span, { className: 'storybook-forms-status-label' }, "Publiek"),
            react_1.default.createElement(storybook_1.Forms.Toggle, { value: !value, onClick: function () { return onChange(!value); } })));
};
exports.FormStatus = FormStatus;
exports.FormStatus.propTypes = {
    /**
     * The value
     */
    value: prop_types_1.default.bool,
    /**
     * onChange listener
     */
    onChange: prop_types_1.default.func,
};
